import { render, staticRenderFns } from "./RegisterAddPacks.vue?vue&type=template&id=02734764"
import script from "./RegisterAddPacks.vue?vue&type=script&lang=js"
export * from "./RegisterAddPacks.vue?vue&type=script&lang=js"
import style0 from "./RegisterAddPacks.vue?vue&type=style&index=0&id=02734764&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports